<template>
    <div class="row">
      <div class="col-md-12">
          <vuestic-widget headerText="Faturas Teóricas">
                <!--Modal de informações-->
                <vuestic-modal :show.sync="modal.show" ref="smallModal" v-bind:small="false" :noButtons="true">
                    <div slot="title">Confirmação de Dados</div>

                    <div v-show="modal.load" >
                        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                            <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                                <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                                >
                                </component>
                            </div>
                        </div>
                    </div>
                    <div v-show="!modal.load">
                        <vuestic-tabs :names="['Dados']" ref="tabs">
                            <div slot="Dados">
                                <div class="row">
                                    <div class="col-md-6 text-center">
                                        <strong class="font-weight-bold">Quantidade de Boletos:</strong><br>
                                        {{ modal.conteudo.length }}
                                    </div>
                                    <div class="col-md-6 text-center">
                                        <strong class="font-weight-bold">Valor:</strong><br>
                                        R$ 37,50 (Por Boleto)
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <strong class="font-weight-bold">Total:</strong><br>
                                        R$ {{ modal.conteudo.length * 37.5 }}
                                    </div>
                                </div>
                                <br><br>
                                <div class="row text-center justify-content-center">
                                    <button v-if="!loadboleto" class="btn btn-primary" @click="gerarFatura">Gerar Fatura</button>
                                    <button v-else class="btn btn-primary" disabled>
                                      <component
                                      :animation-duration="1000"
                                      :is="'SpringSpinner'"
                                      :color="'#4AE387'"
                                      :size="80"
                                      >
                                      </component>
                                    </button>
                                </div>
                            </div>
                        </vuestic-tabs>
                    </div>
                </vuestic-modal>
                <!--Botões da paginação-->

                <div class="row">
                    <div class="col-md-4">
                        <DateIconGroup idInput="data_inicial" iconInput="fa-calendar"
                                    labelInput="Data Inicial">
                            (AAAA-MM-DD)
                        </DateIconGroup>
                    </div>
                    <div class="col-md-4">
                        <DateIconGroup idInput="data_final" iconInput="fa-calendar"
                                    labelInput="Data Final">
                            (AAAA-MM-DD)
                        </DateIconGroup>
                    </div>
                    <div class="col-md-4 text-center justify-content-center">
                        <button class="btn btn-primary" @click="loadData">Consultar</button>
                    </div>
                </div>
                <br>
                <!--Botões da paginação-->
                <div class="row">
                  <div class="col mx-auto">
                    <nav>
                      <ul class="pagination justify-content-center">
                        <li class="page-item disabled" id="previous_page" v-show="table.currentPage == 1">
                          <a class="page-link" href="#" tabindex="-1">Anterior</a>
                        </li>
                        <li class="page-item" id="previous_page" @click.stop="previousPage()" v-show="table.currentPage != 1">
                          <a class="page-link" href="#" tabindex="-1">Anterior</a>
                        </li>                                      
                        <template v-for="(page, index) in table.pages">
                          <li class="page-item" v-show="page !== table.currentPage" @click="page === table.currentPage ? null : pagePaginate(page)" :key="index + page + 'age'"> 
                            <a class="page-link" @click.prevent="page === table.currentPage ? null : pagePaginate(page)" href="#" >{{ page }}</a>
                          </li>
                          <li class="page-item active" v-show="page === table.currentPage"  :key="index"> 
                            <a class="page-link"  href="#" >{{ page }}</a>
                          </li>
                        </template>            
                        <li class="page-item disabled" id="previous_page" v-show="table.lastPage == table.currentPage">
                          <a class="page-link" href="#" tabindex="-1">Próximo</a>
                        </li>
                        <li class="page-item" id="previous_page" @click.stop="nextPage()" v-show="table.lastPage != table.currentPage">              
                          <a class="page-link" href="#" tabindex="-1">Próximo</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <!--Botões da paginação-->
                <!--Tabela-->
                <div class="row">
                    <div class="col-md-12">
                        <table class="table table-responsive-sm">
                            <thead>
                                <tr>
                                    <th v-for="th in tableOptions.thead" :key="th"  scope="col">{{th}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-show="table.load">
                                    <td colspan="7" class="text-center">
                                        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                                            <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                                                <component
                                                    :animation-duration="1000"
                                                    :is="'SpringSpinner'"
                                                    :color="'#4AE387'"
                                                    :size="80"
                                                >
                                                </component>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-show="!table.load" v-for="dados in table.data" class="tb-linha" :key="dados.id_boleto">
                                    <td v-if="!dados.codigo_transacao"><input type="checkbox" :id="'boleto_' + dados.id_boleto" @change="adicionarBoleto(dados)"></td>
                                    <td v-else>-</td>
                                    <td>{{dados.aluno.nome}}</td>
                                    <td>R$ {{dados.valor}}</td>
                                    <td>{{utils.formatDate(dados.vencimento, true)}}</td>
                                    <td>{{utils.formatDate(dados.created_at, true)}}</td>
                                    <td v-if="!dados.codigo_transacao">
                                        <button title="Gerar fatura única" class="btn btn-primary btn-with-icon rounded-icon btn-micro justify-content-center"
                                        @click="gerarBoletos(dados)">
                                            <span aria-hidden="true" class="fa fa-file-text-o" style="padding-left: 3px;"></span>
                                        </button>
                                    </td>
                                    <td v-else-if="dados.cancelado">
                                      <a title="Ver fatura única" class="btn btn-danger btn-with-icon rounded-icon btn-micro justify-content-center">
                                        <span aria-hidden="true" class="fa fa-file-text-o" style="padding-left: 3px;padding-top: 10px;"></span></a>
                                    </td>
                                    <td v-else>
                                      <a title="Ver fatura única" target="_blank" rel="noopener noreferrer" class="btn btn-primary btn-with-icon rounded-icon btn-micro justify-content-center" :href="dados.link_boleto"><span aria-hidden="true" class="fa fa-file-text-o" style="padding-left: 3px;padding-top: 10px;"></span></a>
                                    </td>
                                </tr>
                                <tr v-show="table.data.length === 0 && !table.load">
                                    <td colspan="7" class="text-center">Nenhum registro encontrado.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!--Botões da paginação-->
                <div class="row">
                  <div class="col mx-auto">
                    <nav>
                      <ul class="pagination justify-content-center">
                        <li class="page-item disabled" id="previous_page" v-show="table.currentPage == 1">
                          <a class="page-link" href="#" tabindex="-1">Anterior</a>
                        </li>
                        <li class="page-item" id="previous_page" @click.stop="previousPage()" v-show="table.currentPage != 1">
                          <a class="page-link" href="#" tabindex="-1">Anterior</a>
                        </li>                                      
                        <template v-for="(page, index) in table.pages">
                          <li class="page-item" v-show="page !== table.currentPage" @click="page === table.currentPage ? null : pagePaginate(page)" :key="index + page + 'age'"> 
                            <a class="page-link" @click.prevent="page === table.currentPage ? null : pagePaginate(page)" href="#" >{{ page }}</a>
                          </li>
                          <li class="page-item active" v-show="page === table.currentPage"  :key="index"> 
                            <a class="page-link"  href="#" >{{ page }}</a>
                          </li>
                        </template>            
                        <li class="page-item disabled" id="previous_page" v-show="table.lastPage == table.currentPage">
                          <a class="page-link" href="#" tabindex="-1">Próximo</a>
                        </li>
                        <li class="page-item" id="previous_page" @click.stop="nextPage()" v-show="table.lastPage != table.currentPage">              
                          <a class="page-link" href="#" tabindex="-1">Próximo</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <!--Botões da paginação-->
                <!--Tabela-->
                <br><br>
                <div v-if="select" class="row text-center justify-content-center">
                    <button @click="gerarBoletos()" type="button" class="btn btn-primary">Gerar Faturas Selecionadas</button>
                </div>
          </vuestic-widget>
      </div>
  </div>
</template>

<script>
import FaturasController from './FaturasController'
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import utils from '../../services/utils'

window._ = require('lodash')

export default {
  name: 'FaturasTeoricas',
  components: {
    ...spinners,
    DateIconGroup,
  },
  data () {
    return {
      loadboleto: false,
      modal: {
        show: false,
        load: false,
        conteudo: []
      },
      url: urlApi + '/boletos/teorico',
      tableOptions: { 'thead': ['#', 'Aluno', 'Valor', 'Data de Vencimento', 'Data de Disponibilização', '-'] },
      search: '',
      table: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: false
      },
      select: false,
      unic: true,
      utils: utils,
    }
  },

  methods: {
    callbackDataPaginate (response) {
      let responseData = response.data.dados
      this.table.currentPage = responseData.current_page
      this.table.data = responseData.data
      this.table.firstPageUrl = responseData.first_page_url
      this.table.from = responseData.from
      this.table.lastPage = responseData.last_page
      this.table.lastPageUrl = responseData.last_page_url
      this.table.nextPageUrl = responseData.next_page_url
      this.table.path = responseData.path
      this.table.perPage = responseData.per_page
      this.table.prevPageUrl = responseData.prev_page_url
      this.table.to = responseData.to
      this.table.total = responseData.total

      this.table.pages = []
      for (let i = 1; i <= (responseData.last_page); i++) {
        this.table.pages.push(i)
      }

      this.items = this.table.data

      this.table.load = false;

    },
    nextPage () {
      this.table.load = true      
      this.$http.get(this.table.nextPageUrl + '&search=' + this.search ).then(this.callbackDataPaginate)
    },
    previousPage () {
      this.table.load = true
      this.$http.get(this.table.prevPageUrl + '&search=' + this.search ).then(this.callbackDataPaginate)
    },
    loadData () {
      this.table.load = true

      let ini = document.getElementById('data_inicial').value
      let end = document.getElementById('data_final').value
      var err = false

      if (!ini) {
        FaturasController.launchToast('fa-times', 'Selecione uma data inicial')
        err = true
      }

      if (!end) {
        FaturasController.launchToast('fa-times', 'Selecione uma data final')
        err = true
      }

      if (err) { return }

      this.table.load = true
      this.$http.get(this.url + `?ini=${ini}&end=${end}`).then(this.callbackDataPaginate)
    },
    pagePaginate (page) {
      this.table.load = true
      this.$http.get(this.url + '?search=' + this.search + '&page=' + page).then(this.callbackDataPaginate)
    },

    gerarFatura () {
      let self = this
      self.loadboleto = true;
      FaturasController.gerarBoletoTeorico(self.modal.conteudo).then(function(link){
        self.loadboleto = false;
        self.$refs.smallModal.close()
        console.log(link)
        window.open(link, '_blank');
      });
    },

    adicionarBoleto (boleto) {
      let self = this
      self.select = true
      var input = document.getElementById('boleto_' + boleto.id_boleto)
      if (self.unic) {
        self.modal.conteudo = []
        self.unic = false
      }

      if (input.checked) {
        self.modal.conteudo.push(boleto)
      } else {
        self.modal.conteudo = self.modal.conteudo.filter(data => data.id_boleto !== boleto.id_boleto)
        if (self.modal.conteudo.length === 0) {
          self.select = false
        }
      }
    },
    posicao(index){
      let distancia = index - this.table.currentPage;
      console.log(distancia);
      if(distancia > -3 && distancia < 1){
        return true;
      }
      return false;
    }, 

    gerarBoletos: function (boleto = null) {
      let self = this
      self.$refs.smallModal.open()
      self.modal.load = true

      if (boleto) {
        self.modal.conteudo = []
        var checkboxes = document.getElementsByTagName('input')
        for (var i = 0; i < checkboxes.length; i++) {
          if (checkboxes[i].type === 'checkbox') {
            checkboxes[i].checked = false
          }
        }
        self.select = false
        self.modal.conteudo.push(boleto)
        self.unic = true
        self.modal.load = false
      } else {
        self.modal.load = false
      }
    }
  }
}
</script>

<style type="text/css" scoped>
  .tb-opcoes {
    display: block;
    position: absolute;
    right: 20px;
    margin-top:-8px;
  }
  .tb-linha:hover .tb-opcoes {
    display: block;
  }

  @media (max-width: 1200px) {
    .tb-opcoes {
      display: block;
    }
  }
  .circle {
    width: .75rem;
    height: .75rem;
    border-radius: 50%;
    display: inline-block;
  }
</style>
